import { PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import React from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setBailiffDialogPlay } from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
import { bailiffDialogPlaySelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ButtonPlay = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const play = useSelector(bailiffDialogPlaySelector);
  const icon = !play ? <PlayCircleOutlined /> : <PauseCircleOutlined />;
  const title = !play ? "Nghe lại" : "Ngưng";
  // -------------------------- FUNCTION ------------------------
  const handlePlay = () => {
    dispatch(setBailiffDialogPlay(!play));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title={title}>
      <Button onClick={handlePlay} type="text" size="large" icon={icon} />
    </Tooltip>
  );
};
export default ButtonPlay;
